<template>
    <transition name="fade">
        <div ref="tooltip" class="tooltip fast" :class="tooltip.class" v-show="showTooltip">
            <transition name="nudge-down">
                <div class="tooltip-inner fast" v-show="showTooltip" role="alert">{{ tooltip.message }}</div>
            </transition>
            <div data-popper-arrow></div>
        </div>
    </transition>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { createPopper } from '@popperjs/core';
    import { dom } from '../utils';

    export default {
        name: 'Tooltip',
        data() {
            return {
                showTooltip: false,
                triggerElem: undefined,
                popper: undefined,
            };
        },
        computed: {
            ...mapGetters({
                tooltip: 'tooltip/get',
            }),
        },
        methods: {
            hide(e) {
                this.showTooltip = false;
                setTimeout(() => {
                    this.$store.commit('tooltip/clear');
                }, 300);
            },
        },
        async mounted() {
            if (typeof this.tooltip.trigger === 'object') {
                this.triggerElem = this.tooltip.trigger;
            } else {
                this.triggerElem = document.querySelector(this.tooltip.trigger);
            }

            this.popper = createPopper(this.triggerElem, this.$refs.tooltip, {
                placement: this.tooltip.position,
                modifiers: [
                    {
                        name: 'arrow',
                        options: {
                            padding: 5,
                        },
                    },
                ],
            });

            this.showTooltip = true;

            await this.$nextTick();
            this.popper.forceUpdate();

            let focusEl;
            if (this.triggerElem.tabIndex >= 0) {
                focusEl = this.triggerElem;
            } else {
                focusEl = dom.focusableElements(this.triggerElem)[0];
            }
            if (focusEl) focusEl.focus();

            setTimeout(() => {
                document.addEventListener('input', this.hide);
                document.addEventListener('click', this.hide);
            }, 300);
        },
        beforeDestroy() {
            document.removeEventListener('input', this.hide);
            document.removeEventListener('click', this.hide);
            if (this.popper) this.popper.destroy();
        },
    };
</script>

<style lang='scss' scoped>
    .tooltip {
        z-index: 1008;
        max-width: 400px;
    }

    ::v-deep .tooltip-inner {
        @include box-shadow-small;
        @include border-radius-small;

        background: $color-white;
        overflow-y: auto;
    }
</style>